import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-fluid p-formgrid p-grid p-m-1" }
const _hoisted_2 = {
  id: "type-container",
  class: "p-field p-d-flex p-ai-center p-m-2  p-col-11"
}
const _hoisted_3 = { class: "p-mx-2" }
const _hoisted_4 = {
  for: "fileType",
  class: "p-ml-1"
}
const _hoisted_5 = {
  for: "tableType",
  class: "p-ml-1"
}
const _hoisted_6 = { class: "p-field p-float-label p-col-6 p-mt-2" }
const _hoisted_7 = {
  for: "version",
  class: "kn-material-input-label"
}
const _hoisted_8 = {
  key: 0,
  class: "p-field p-col-6 p-mt-2"
}
const _hoisted_9 = { class: "p-float-label" }
const _hoisted_10 = {
  for: "fieldDelimiter",
  class: "kn-material-input-label"
}
const _hoisted_11 = {
  key: 1,
  class: "p-field p-col-6 p-mt-2"
}
const _hoisted_12 = { class: "p-float-label" }
const _hoisted_13 = {
  for: "tableName",
  class: "kn-material-input-label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")
  const _component_InlineMessage = _resolveComponent("InlineMessage")
  const _component_RadioButton = _resolveComponent("RadioButton")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    id: "olap-wizard-dialog",
    class: "p-fluid kn-dialog--toolbar--primary",
    style: _ctx.descriptor.style.dialog,
    visible: _ctx.visible,
    modal: true,
    closable: false
  }, {
    header: _withCtx(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-p-0 p-m-2 p-col-12" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('documentExecution.olap.outputWizard.title')), 1)
        ]),
        _: 1
      })
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        class: "kn-button kn-button--secondary",
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('close')))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.close')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_Button, {
        class: "kn-button kn-button--primary",
        disabled: _ctx.saveDisabled,
        onClick: _ctx.saveRequest
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ]),
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_ProgressSpinner, {
            key: 0,
            class: "wizard-overlay-spinner",
            style: _ctx.descriptor.style.spinner
          }, null, 8, ["style"]))
        : _createCommentVNode("", true),
      _createVNode("form", _hoisted_1, [
        _createVNode(_component_InlineMessage, {
          class: "p-m-1",
          severity: "info",
          closable: "false"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('documentExecution.olap.outputWizard.infoMsg')), 1)
          ]),
          _: 1
        }),
        _createVNode("div", _hoisted_2, [
          _createVNode("span", null, _toDisplayString(_ctx.$t('managers.workspaceManagement.dataPreparation.transformations.outputType')) + ": ", 1),
          _createVNode("div", _hoisted_3, [
            _createVNode(_component_RadioButton, {
              id: "fileType",
              name: "file",
              value: "file",
              modelValue: _ctx.selectedType,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedType = $event))
            }, null, 8, ["modelValue"]),
            _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('common.file')), 1)
          ]),
          _createVNode("div", null, [
            _createVNode(_component_RadioButton, {
              id: "tableType",
              name: "table",
              value: "table",
              modelValue: _ctx.selectedType,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedType = $event))
            }, null, 8, ["modelValue"]),
            _createVNode("label", _hoisted_5, _toDisplayString(_ctx.$t('common.table.table')), 1)
          ])
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode(_component_Dropdown, {
            id: "version",
            class: "kn-material-input",
            modelValue: _ctx.selectedVersion,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectedVersion = $event)),
            options: _ctx.olapVersionsProp,
            optionLabel: "name"
          }, null, 8, ["modelValue", "options"]),
          _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('documentExecution.olap.outputWizard.version')), 1)
        ]),
        (_ctx.selectedType === 'file' && _ctx.selectedVersion)
          ? (_openBlock(), _createBlock("div", _hoisted_8, [
              _createVNode("span", _hoisted_9, [
                _createVNode(_component_InputText, {
                  id: "fieldDelimiter",
                  class: "kn-material-input",
                  modelValue: _ctx.fieldDelimiter,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.fieldDelimiter = $event))
                }, null, 8, ["modelValue"]),
                _createVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('documentExecution.olap.outputWizard.fieldDelimiter')), 1)
              ]),
              _createVNode("small", null, _toDisplayString(_ctx.$t('documentExecution.olap.outputWizard.fileInfo')), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.selectedType === 'table' && _ctx.selectedVersion)
          ? (_openBlock(), _createBlock("div", _hoisted_11, [
              _createVNode("span", _hoisted_12, [
                _createVNode(_component_InputText, {
                  id: "tableName",
                  class: "kn-material-input",
                  modelValue: _ctx.tableName,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.tableName = $event))
                }, null, 8, ["modelValue"]),
                _createVNode("label", _hoisted_13, _toDisplayString(_ctx.$t('managers.datasetManagement.flatTableName')), 1)
              ]),
              _createVNode("small", null, _toDisplayString(_ctx.$t('documentExecution.olap.outputWizard.tableInfo')), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["style", "visible"]))
}